<template>
  <div class="list-page">
    <b-container class="container-rda">
      <b-row>
        <b-col class="content">
          <b-row>
            <b-col>
              <Breadcrumb :breadcrumb="breadcrumb" />
            </b-col>
          </b-row>

          <b-row class="mb-5">
            <b-col>
              <h2 class="purple bold">
                Lançamento Coletivo - Registros Antigos
              </h2>
            </b-col>
          </b-row>

          <b-row style="padding-bottom: 10px">
            <b-col md="9">
              <p class="purple">Filtre para obter resultados</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <div v-if="loadingVersions" class="spinner-container">
                <b-spinner small></b-spinner>
                <span class="ml-2">Carregando versões...</span>
              </div>
              <SelectSimple
                v-else-if="versionOptions.length"
                v-model="selectedVersion"
                :options="versionOptions"
                :callback="selectVersion"
                label="Versão do currículo"
              />
            </b-col>

            <b-col md="3" v-if="selectedVersion">
              <div v-if="loadingCycles" class="spinner-container">
                <b-spinner small></b-spinner>
                <span class="ml-2">Carregando ciclos...</span>
              </div>
              <SelectSimple
                v-else-if="allCycles.length"
                v-model="selectedCycle"
                label="Ciclo"
                :options="allCycles"
                :callback="selectCycle"
              />
              <div v-if="selectedCycle && !loadingCycles">
                <span class="clear-field" @click="clearSubject"
                  >Limpar filtro</span
                >
              </div>
            </b-col>

            <b-col
              md="3"
              v-if="
                selectedCycle && !loadingSubjects && listSubjects.length > 0
              "
            >
              <SelectSimple
                v-model="selectedDisciplinary"
                label="Área do conhecimento"
                :options="subjectsSel"
                :callback="selectDisciplinary"
              />
            </b-col>
            <b-col md="3" v-else-if="selectedCycle && loadingSubjects">
              <div class="spinner-container">
                <b-spinner small></b-spinner>
                <span class="ml-2">Carregando áreas do conhecimento...</span>
              </div>
            </b-col>

            <b-col md="2" v-if="selectedCycle">
              <div v-if="loadingClassrooms" class="spinner-container">
                <b-spinner small></b-spinner>
                <span class="ml-2">Carregando turmas...</span>
              </div>
              <b-form-group v-else label="Turma atual">
                <multiselect
                  v-model="classroomsSelAux"
                  :options="classroomsSel"
                  :multiple="true"
                  placeholder="Selecione"
                  label="designation"
                  track-by="id"
                  selectLabel=""
                  @select="callbackClassrooms"
                  @remove="callbackRemoveClassrooms"
                  :disabled="classroomsSel.length === 0"
                >
                  <span slot="noResult">Nada encontrado</span>
                </multiselect>
              </b-form-group>
              <span
                v-if="classroomsSelAux.length > 0 && !loadingClassrooms"
                class="clear-field"
                @click="clearFields"
                >Limpar filtros</span
              >
            </b-col>
          </b-row>

          <b-row v-if="false">
            <b-col>
              <b-container class="list-top" fluid>
                <b-row class="header-list-teacher" v-if="orderbyName.length">
                  <b-col md="7">
                    <p class="bold">Aluno</p>
                  </b-col>
                  <b-col md="2">
                    <p class="bold">Progresso</p>
                  </b-col>
                  <b-col>
                    <p class="bold">Avaliar</p>
                  </b-col>
                  <b-col>
                    <p class="bold">Visualizar</p>
                  </b-col>
                </b-row>
              </b-container>
              <b-container fluid>
                <b-row
                  align-v="center"
                  class="list-teacher"
                  v-for="(student, index) in this.orderbyName"
                  :key="index"
                >
                  <b-col md="7">
                    <p>{{ student.name }}</p>
                  </b-col>

                  <b-col md="2">
                    <b-row class="row-progress" align-v="center" no-gutters>
                      <b-col>
                        <span
                          >{{ Number(student.percentage).toFixed(0) }}%</span
                        >
                      </b-col>
                      <b-col cols="9">
                        <b-progress
                          :value="student.percentage"
                          :class="
                            `${student.percentage <= 10 ? 'red' : ''}` ||
                            `${student.percentage < 60 ? 'orange' : ''}` ||
                            `${student.percentage < 90 ? 'yellow' : ''}` ||
                            `${student.percentage >= 90 ? 'green' : ''}`
                          "
                        ></b-progress>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col>
                    <RateIcon
                      :class="{ inactive: !student.is_for_evaluation }"
                    />
                  </b-col>

                  <b-col>
                    <router-link
                      :to="{
                        name: 'registrar-aprendizagens',
                        params: { id: student.id, subject_id: subject },
                      }"
                    >
                      <ViewIcon />
                    </router-link>
                  </b-col>
                </b-row>

                <b-row
                  align-v="center"
                  class="list-teacher"
                  v-if="wasRequestMade && !orderbyName.length"
                >
                  <b-col>Nenhum resultado encontrado</b-col>
                </b-row>

                <b-row
                  class="align-center"
                  v-else-if="count > perPage && wasRequestMade"
                >
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="count"
                    aria-controls="teachersList"
                    last-text
                    first-text
                  >
                    <template #prev-text>
                      <LeftArrowIcon class="left" />
                    </template>
                    <template #next-text>
                      <LeftArrowIcon />
                    </template>
                  </b-pagination>
                </b-row>
              </b-container>
            </b-col>
          </b-row>

          <b-row v-if="this.typeId === 2" class="wrap-competence-selected">
            <b-col
              v-if="
                topicsSelected.length > 0 ||
                (studentsSelected.length > 0 &&
                  selectedDisciplinary &&
                  competencesList.length > 0)
              "
            >
              <div class="d-flex justify-content-between align-items-center">
                <p class="bold">Selecionados</p>
                <button
                  :class="
                    topicsSelected.length
                      ? 'btn-remove-all-topics'
                      : 'btn-add-all-topics'
                  "
                  @click="addAllTopics"
                >
                  {{
                    topicsSelected.length
                      ? "Desmarcar todos os conteúdos"
                      : `Selecionar todos os conteúdos`
                  }}
                </button>
              </div>
              <b-container fluid class="box-content">
                <div>
                  <p class="bold" style="font-size: 20px">Conteúdos</p>
                  <div class="competence-items-grouped">
                    <div
                      v-for="(group, groupIndex) in topicsGroupedByTematicUnit"
                      :key="groupIndex"
                      class="tematic-unit-group"
                    >
                      <div class="tematic-unit-header" v-if="group.tematicUnit">
                        <strong
                          style="font-size: 18px"
                          v-if="
                            group.competenceModality && group.competenceDetails
                          "
                          >{{ group.competenceModality }} -
                          {{ group.competenceDetails }}</strong
                        ><br />
                        <strong style="font-size: 18px"
                          >Unidade Temática:</strong
                        >
                        {{ group.tematicUnit.description }}<br />
                        <strong style="font-size: 18px">Competência:</strong>
                        {{ group.competenceDescription }}
                      </div>

                      <ul class="competence-items-selected">
                        <li
                          v-for="topic in group.topics"
                          :key="topic.id"
                          style="display: flex; align-items: center; gap: 10px"
                        >
                          <span style="flex: 1; min-width: 0">
                            <span v-if="topic.KnowledgeObject">
                              <strong>{{ topic.sortOrder }}</strong
                              >&nbsp; <strong>Objeto de Conhecimento: </strong
                              >{{ topic.KnowledgeObject.description }}
                              <br />
                              <strong>Conteúdo: </strong>
                              {{ topic.description }}
                            </span>

                            <span v-if="!topic.KnowledgeObject">
                              <strong>{{ topic.sortOrder }} Conteúdo: </strong
                              >{{ topic.description }}
                            </span>
                          </span>
                          <span
                            class="remove-item"
                            @click="removeTopics(topic.id)"
                            style="flex-shrink: 0"
                          ></span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p class="bold">Alunos</p>
                    <button
                      v-if="studentsSelected.length > 0"
                      class="btn-remove-all-topics"
                      @click="removeAllStudents"
                    >
                      Remover alunos
                    </button>
                  </div>
                  <div class="students-items-selected">
                    <div
                      v-for="(student, index) in studentsSelected"
                      :key="index"
                      @click="removeStudent(index, student)"
                      class="img-student"
                      v-b-tooltip.hover
                      :title="student.User.name"
                    >
                      <figure
                        :style="{
                          backgroundImage: `url(${student.User.photo})`,
                        }"
                      >
                        <span>
                          <ArrowUpStudents />
                        </span>
                      </figure>
                    </div>
                  </div>
                </div>
                <div class="wrap-btn-submit">
                  <b-col class="boxStatus">
                    <p
                      v-for="(status, index) in learningStatus"
                      v-bind:key="index"
                    >
                      <span
                        class="statusButton"
                        v-if="statusSelected !== status"
                        @click="selectStatus(status)"
                        >{{ status }}</span
                      >
                      <span
                        v-if="statusSelected === status"
                        class="statusButton active"
                        @click="cleanStatus"
                      >
                        {{ status }}
                      </span>
                    </p>
                  </b-col>
                  <b-button
                    class="btn large blue"
                    v-if="
                      studentsSelected.length > 0 && topicsSelected.length > 0
                    "
                    @click="register"
                    >Registrar
                  </b-button>
                </div>
              </b-container>
            </b-col>
            <b-col v-else>
              <template
                v-if="
                  selectedCycle &&
                  this.listSubjects.length > 0 &&
                  selectedDisciplinary &&
                  competencesList.length > 0
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <p class="bold">Selecionados</p>
                  <button
                    :class="
                      topicsSelected.length
                        ? 'btn-remove-all-topics'
                        : 'btn-add-all-topics'
                    "
                    @click="addAllTopics"
                  >
                    {{
                      topicsSelected.length
                        ? `Desmarcar todos os conteúdos`
                        : `Selecionar todos os conteúdos`
                    }}
                  </button>
                </div>
                <b-container
                  fluid
                  class="box-content alignTextBox"
                  v-if="
                    this.competencesList.length > 0 &&
                    this.listSubjects.length > 0
                  "
                >
                  <p>Selecione os conteúdos e os alunos.</p>
                </b-container>
              </template>
            </b-col>
          </b-row>

          <b-row
            class="wrap-competence-selected"
            v-if="
              this.listSubjects.length === 0 &&
              selectedCycle &&
              !loadingSubjects
            "
          >
            <b-col>
              <b-container fluid class="box-content alignTextBox">
                <p>Não existe áreas do conhecimento para esta turma</p>
              </b-container>
            </b-col>
          </b-row>

          <b-row
            v-if="
              this.typeId === 2 &&
              this.competencesList.length > 0 &&
              this.listSubjects.length > 0
            "
            class="wrap-competence"
          >
            <b-col v-if="!isGrouped">
              <b-container fluid>
                <div class="box-content">
                  <div class="col list">
                    <div class="header-knowledge-field">
                      <p class="bold" style="font-size: 20px">Conteúdos</p>
                    </div>
                    <div
                      class="col-content"
                      v-for="(competence, index) in competencesWithoutModality(
                        competencesList
                      )"
                      :key="competence.id"
                    >
                      <Accordion :index="competence.sort_order">
                        <div slot="title" v-if="competence.details">
                          <h5>{{ competence.details }}</h5>
                        </div>
                        <div slot="title" v-if="competence.TematicUnit">
                          <h4>
                            Unidade Temática:
                            {{ competence.TematicUnit.description }}
                          </h4>
                        </div>
                        <div slot="title">
                          <strong> Competência:</strong>
                          {{ competence.description }}
                        </div>

                        <div slot="content">
                          <button
                            :class="
                              areAllTopicsFromCompetenceAdded(competence.id)
                                ? 'btn-remove-all-topics'
                                : 'btn-add-all-topics'
                            "
                            @click="addAllTopicsFromCompetences(competence.id)"
                          >
                            {{
                              areAllTopicsFromCompetenceAdded(competence.id)
                                ? "Desmarcar todos da unidade temática"
                                : `Selecionar
                            todos da
                            unidade temática`
                            }}
                          </button>
                          <ul class="list-competence">
                            <li
                              v-for="(topics, indexTopic) in competence.Topics"
                              :key="topics.id"
                            >
                              <p
                                v-if="
                                  !topicsSelected.find(
                                    (selected) => selected.id === topics.id
                                  )
                                "
                              >
                                <span v-if="topics.KnowledgeObject">
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Objeto de Conhecimento:</strong
                                  >
                                  {{ topics.KnowledgeObject.description }}
                                  <br />
                                  <strong>Conteúdo:</strong>
                                  {{ topics.description }}
                                </span>
                                <span v-else>
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Conteúdo:</strong
                                  >
                                  {{ topics.description }}
                                </span>
                              </p>
                              <p v-else class="list-competence-selected">
                                <span v-if="topics.KnowledgeObject">
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Objeto de Conhecimento:</strong
                                  >
                                  {{ topics.KnowledgeObject.description }}
                                  <br />
                                  <strong>Conteúdo:</strong>
                                  {{ topics.description }}
                                </span>
                                <span v-else>
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Conteúdo:</strong
                                  >
                                  {{ topics.description }}
                                </span>
                              </p>
                              <span
                                v-if="
                                  !topicsSelected.find(
                                    (selected) => selected.id === topics.id
                                  )
                                "
                                class="btn-plus"
                                @click="
                                  addTopics(
                                    topics,
                                    (competence.user_sort_order ||
                                      competence.sort_order) +
                                      '.' +
                                      topics.sort_order,
                                    indexTopic,
                                    index
                                  )
                                "
                                >+</span
                              >
                            </li>
                          </ul>
                        </div>
                      </Accordion>
                    </div>
                  </div>
                  <div class="col students-list">
                    <p class="bold">
                      Alunos ({{ filteredStudentList.length }})
                    </p>
                    <div class="col-content">
                      <p class="about">
                        Clique no(s) aluno(s) que deseja inserir na competência
                        selecionada.
                      </p>
                      <p
                        class="about"
                        style="font-size: 12px; color: #666; margin-top: 5px"
                      >
                        <strong>Nota:</strong> Alguns alunos podem estar em
                        outros ciclos, mas aparecem nesta lista porque em seu
                        histórico foram encontrados conteúdos da versão do ciclo
                        selecionado.
                      </p>
                      <div class="wrap-search-students">
                        <form @submit.prevent="search">
                          <b-form-group>
                            <div
                              class="d-flex justify-content-between align-items-center mb-2"
                            >
                              <label class="mb-0">Buscar alunos </label>
                              <b-button
                                size="sm"
                                class="btn-add-all-topics"
                                style="margin-bottom: 0; font-weight: normal"
                                v-if="
                                  this.subject > 0 &&
                                  this.typeId === 2 &&
                                  filteredStudentList.length
                                "
                                @click="addAllFilteredStudents"
                              >
                                Adicionar Todos
                              </b-button>
                            </div>

                            <b-input-group>
                              <b-form-input
                                v-model="searchStudentList"
                                type="search"
                                placeholder="Buscar por aluno"
                              />
                              <b-input-group-append
                                v-if="searchStudentList !== ''"
                              >
                                <b-button
                                  variant="light"
                                  class="clear-fields"
                                  v-b-tooltip.hover
                                  title="Limpar Pesquisa"
                                  @click="clearStudentList"
                                >
                                  <b-icon icon="x"></b-icon>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </form>
                      </div>

                      <div v-if="loadingStudents" class="text-center py-3">
                        <b-spinner small></b-spinner>
                        <span class="ml-2">Carregando alunos...</span>
                      </div>

                      <span
                        class="empty-student-list"
                        v-else-if="this.filteredStudentList.length <= 0"
                        >Nenhum aluno encontrado.</span
                      >
                      <ul v-else-if="this.filteredStudentList.length > 0">
                        <li
                          v-for="(item, index) in this.filteredStudentList"
                          :key="`student-${index}`"
                          @click="selectStudent(item)"
                        >
                          <div class="img-student">
                            <figure
                              :style="{
                                backgroundImage: 'url(' + item.User.photo + ')',
                              }"
                            >
                              <span>
                                <ArrowUpStudents />
                              </span>
                            </figure>
                          </div>
                          <div class="info-studante">
                            <span>{{ item.User.name }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-container>
            </b-col>

            <b-col v-if="isGrouped">
              <b-container fluid>
                <div class="box-content">
                  <div class="col list">
                    <div class="header-knowledge-field">
                      <p class="bold" style="font-size: 20px">Conteúdos</p>
                    </div>

                    <div
                      class="col-content"
                      v-for="(competence, index) in competencesWithoutModality(
                        competencesList
                      )"
                      :key="`no-modality-${competence.id}`"
                    >
                      <Accordion :index="competence.sort_order">
                        <div slot="title" v-if="competence.details">
                          <h5>{{ competence.details }}</h5>
                        </div>
                        <div slot="title" v-if="competence.TematicUnit">
                          <h4>
                            Unidade Temática:
                            {{ competence.TematicUnit.description }}
                          </h4>
                        </div>
                        <div slot="title">
                          <strong>Competência:</strong>
                          {{ competence.description }}
                        </div>

                        <div slot="content">
                          <button
                            :class="
                              areAllTopicsFromCompetenceAdded(competence.id)
                                ? 'btn-remove-all-topics'
                                : 'btn-add-all-topics'
                            "
                            @click="addAllTopicsFromCompetences(competence.id)"
                          >
                            {{
                              areAllTopicsFromCompetenceAdded(competence.id)
                                ? "Desmarcar todos da unidade temática"
                                : "Selecionar todos da unidade temática"
                            }}
                          </button>
                          <ul class="list-competence">
                            <li
                              v-for="(topics, indexTopic) in competence.Topics"
                              :key="topics.id"
                            >
                              <p
                                v-if="
                                  !topicsSelected.find(
                                    (selected) => selected.id === topics.id
                                  )
                                "
                              >
                                <span v-if="topics.KnowledgeObject">
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Objeto de Conhecimento:</strong
                                  >
                                  {{ topics.KnowledgeObject.description }}
                                  <br />
                                  <strong>Conteúdo:</strong>
                                  {{ topics.description }}
                                </span>
                                <span v-else>
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Conteúdo:</strong
                                  >
                                  {{ topics.description }}
                                </span>
                              </p>
                              <p v-else class="list-competence-selected">
                                <span v-if="topics.KnowledgeObject">
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Objeto de Conhecimento:</strong
                                  >
                                  {{ topics.KnowledgeObject.description }}
                                  <br />
                                  <strong>Conteúdo:</strong>
                                  {{ topics.description }}
                                </span>
                                <span v-else>
                                  <strong
                                    ><span
                                      >{{
                                        competence.user_sort_order ||
                                        competence.sort_order
                                      }}.{{ topics.sort_order }}</span
                                    >
                                    Conteúdo:</strong
                                  >
                                  {{ topics.description }}
                                </span>
                              </p>
                              <span
                                v-if="
                                  !topicsSelected.find(
                                    (selected) => selected.id === topics.id
                                  )
                                "
                                class="btn-plus"
                                @click="
                                  addTopics(
                                    topics,
                                    competence.user_sort_order ||
                                      competence.sort_order +
                                        '.' +
                                        topics.sort_order,
                                    indexTopic,
                                    index
                                  )
                                "
                              >
                                +
                              </span>
                            </li>
                          </ul>
                        </div>
                      </Accordion>
                    </div>
                    <div v-if="hasLanguageCompetences">
                      <template
                        v-for="(
                          levelGroup, levelName
                        ) in groupedLanguagesByLevel(
                          competencesWithDetailsOnly(competencesList)
                        )"
                      >
                        <div
                          :key="`language-level-${levelName}`"
                          class="level-group col-content"
                          style="row-gap: 0"
                        >
                          <b-card-header
                            header-tag="header"
                            role="tab"
                            style="
                              border: 1px solid #dee2e6;
                              border-radius: 10px;
                              cursor: pointer;
                            "
                            v-b-toggle="
                              'accordion-language-level-' +
                              getLevelId('language', levelName)
                            "
                            class="accordion-header"
                          >
                            <div class="level-header-content">
                              <h5 style="color: #b23066">
                                {{ levelName }}
                              </h5>

                              <button
                                :class="
                                  areAllTopicsFromLanguageLevelAdded(levelName)
                                    ? 'btn-remove-all-topics-small'
                                    : 'btn-add-all-topics-small'
                                "
                                @click.stop="
                                  addAllTopicsFromLanguageLevel(levelName)
                                "
                                :title="
                                  areAllTopicsFromLanguageLevelAdded(levelName)
                                    ? 'Desmarcar todos do nível'
                                    : 'Selecionar todos do nível'
                                "
                              >
                                {{
                                  areAllTopicsFromLanguageLevelAdded(levelName)
                                    ? "Desmarcar todos do nível"
                                    : "Selecionar todos do nível"
                                }}
                              </button>
                            </div>
                          </b-card-header>

                          <b-collapse
                            :id="
                              'accordion-language-level-' +
                              getLevelId('language', levelName)
                            "
                            role="tabpanel"
                            style="padding-left: 10px"
                          >
                            <template
                              v-for="(
                                competence, competenceIndex
                              ) in levelGroup"
                            >
                              <div
                                :key="`language-competence-${competence.id}`"
                                class="competence-group"
                                style="
                                  background-color: #f0f0f0;
                                  border-radius: 10px;
                                "
                              >
                                <b-card-header
                                  header-tag="header"
                                  role="tab"
                                  class="competence-header"
                                  style="
                                    margin-bottom: 5px;
                                    justify-content: flex-start;
                                    align-items: center;
                                    gap: 10px;
                                    padding: 24px;
                                  "
                                  v-b-toggle="
                                    'accordion-language-competence-' +
                                    competence.id
                                  "
                                >
                                  <div class="competence-content-wrapper">
                                    <div>
                                      <h3>
                                        {{ competence.sort_order }}
                                      </h3>
                                    </div>
                                    <div>
                                      <h6>
                                        <div v-if="competence.TematicUnit">
                                          <p
                                            style="
                                              font-weight: bold;
                                              margin-bottom: 0;
                                              text-transform: uppercase;
                                              padding-bottom: 5px;
                                              font-size: 16px;
                                            "
                                          >
                                            <strong>Unidade Temática:</strong>
                                            {{
                                              competence.TematicUnit.description
                                            }}
                                          </p>
                                        </div>
                                        <div>
                                          <p
                                            style="
                                              font-weight: normal;
                                              margin-bottom: 0;
                                              font-size: 16px;
                                            "
                                          >
                                            <strong>Competência:</strong>
                                            {{ competence.description }}
                                          </p>
                                        </div>
                                      </h6>
                                    </div>
                                  </div>
                                </b-card-header>

                                <b-collapse
                                  :id="
                                    'accordion-language-competence-' +
                                    competence.id
                                  "
                                  role="tabpanel"
                                >
                                  <div class="competence-content">
                                    <button
                                      style="margin-bottom: 5px"
                                      :class="
                                        areAllTopicsFromCompetenceAdded(
                                          competence.id
                                        )
                                          ? 'btn-remove-all-topics'
                                          : 'btn-add-all-topics'
                                      "
                                      @click="
                                        addAllTopicsFromCompetences(
                                          competence.id
                                        )
                                      "
                                    >
                                      {{
                                        areAllTopicsFromCompetenceAdded(
                                          competence.id
                                        )
                                          ? `Desmarcar todos da unidade
                                      temática`
                                          : "Selecionar todos da unidade temática"
                                      }}
                                    </button>

                                    <ul
                                      class="list-competence"
                                      style="padding-left: 0px"
                                    >
                                      <li
                                        v-for="(
                                          topics, indexTopic
                                        ) in competence.Topics"
                                        :key="topics.id"
                                      >
                                        <p
                                          v-if="
                                            !topicsSelected.find(
                                              (selected) =>
                                                selected.id === topics.id
                                            )
                                          "
                                        >
                                          <span v-if="topics.KnowledgeObject">
                                            <strong
                                              ><span
                                                >{{ competence.sort_order }}.{{
                                                  topics.sort_order
                                                }}</span
                                              >
                                              Objeto de Conhecimento:</strong
                                            >
                                            {{
                                              topics.KnowledgeObject.description
                                            }}
                                            <br />
                                            <strong>Conteúdo:</strong>
                                            {{ topics.description }}
                                          </span>
                                          <span v-else>
                                            <strong
                                              ><span
                                                >{{ competence.sort_order }}.{{
                                                  topics.sort_order
                                                }}</span
                                              >
                                              Conteúdo:</strong
                                            >
                                            {{ topics.description }}
                                          </span>
                                        </p>
                                        <p
                                          v-else
                                          class="list-competence-selected"
                                        >
                                          <span v-if="topics.KnowledgeObject">
                                            <strong
                                              ><span
                                                >{{ competence.sort_order }}.{{
                                                  topics.sort_order
                                                }}</span
                                              >
                                              Objeto de Conhecimento:</strong
                                            >
                                            {{
                                              topics.KnowledgeObject.description
                                            }}
                                            <br />
                                            <strong>Conteúdo:</strong>
                                            {{ topics.description }}
                                          </span>
                                          <span v-else>
                                            <strong
                                              ><span
                                                >{{ competence.sort_order }}.{{
                                                  topics.sort_order
                                                }}</span
                                              >
                                              Conteúdo:</strong
                                            >
                                            {{ topics.description }}
                                          </span>
                                        </p>
                                        <span
                                          v-if="
                                            !topicsSelected.find(
                                              (selected) =>
                                                selected.id === topics.id
                                            )
                                          "
                                          class="btn-plus"
                                          @click="
                                            addTopics(
                                              topics,
                                              competence.sort_order +
                                                '.' +
                                                topics.sort_order,
                                              indexTopic,
                                              competenceIndex
                                            )
                                          "
                                        >
                                          +
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </b-collapse>
                              </div>
                            </template>
                          </b-collapse>
                        </div>
                      </template>
                    </div>

                    <div v-else>
                      <template
                        v-for="(
                          modalityLevels, modalityName
                        ) in groupedByModalityAndLevel(competencesList)"
                      >
                        <div
                          :key="`modality-${modalityName}`"
                          class="modality-group col-content"
                          style="row-gap: 0"
                        >
                          <b-card-header
                            header-tag="header"
                            role="tab"
                            style="
                              border: 1px solid #dee2e6;
                              border-radius: 10px;
                              cursor: pointer;
                            "
                            v-b-toggle="
                              'accordion-modality-grouped-' +
                              getModalityId(modalityName)
                            "
                            class="accordion-header"
                          >
                            <div class="modality-header-content">
                              <h5 style="color: #000">
                                {{ modalityName }}
                              </h5>

                              <button
                                :class="
                                  areAllTopicsFromModalityAdded(modalityName)
                                    ? 'btn-remove-all-topics-small'
                                    : 'btn-add-all-topics-small'
                                "
                                @click.stop="
                                  addAllTopicsFromModality(modalityName)
                                "
                                :title="
                                  areAllTopicsFromModalityAdded(modalityName)
                                    ? 'Desmarcar todos da modalidade'
                                    : 'Selecionar todos da modalidade'
                                "
                              >
                                {{
                                  areAllTopicsFromModalityAdded(modalityName)
                                    ? "Desmarcar todos da modalidade"
                                    : "Selecionar todos da modalidade"
                                }}
                              </button>
                            </div>
                          </b-card-header>

                          <b-collapse
                            :id="
                              'accordion-modality-grouped-' +
                              getModalityId(modalityName)
                            "
                            role="tabpanel"
                            style="padding: 0; border: none; padding-left: 0px"
                          >
                            <div
                              v-for="(levelGroup, levelName) in modalityLevels"
                              :key="`level-${levelName}`"
                              class="level-group"
                            >
                              <b-card-header
                                header-tag="header"
                                role="tab"
                                style="
                                  border: 1px solid #dee2e6;
                                  border-radius: 10px;
                                  cursor: pointer;
                                "
                                v-b-toggle="
                                  'accordion-level-grouped-' +
                                  getLevelId(modalityName, levelName)
                                "
                                class="accordion-header"
                              >
                                <div class="level-header-content">
                                  <h5 style="color: #b23066">
                                    {{ levelName }}
                                  </h5>

                                  <button
                                    :class="
                                      areAllTopicsFromLevelAdded(
                                        modalityName,
                                        levelName
                                      )
                                        ? 'btn-remove-all-topics-small'
                                        : 'btn-add-all-topics-small'
                                    "
                                    @click.stop="
                                      addAllTopicsFromLevel(
                                        modalityName,
                                        levelName
                                      )
                                    "
                                    :title="
                                      areAllTopicsFromLevelAdded(
                                        modalityName,
                                        levelName
                                      )
                                        ? 'Desmarcar todos do nível'
                                        : 'Selecionar todos do nível'
                                    "
                                  >
                                    {{
                                      areAllTopicsFromLevelAdded(
                                        modalityName,
                                        levelName
                                      )
                                        ? "Desmarcar todos do nível"
                                        : "Selecionar todos do nível"
                                    }}
                                  </button>
                                </div>
                              </b-card-header>

                              <b-collapse
                                :id="
                                  'accordion-level-grouped-' +
                                  getLevelId(modalityName, levelName)
                                "
                                role="tabpanel"
                                style="padding-left: 10px"
                              >
                                <template
                                  v-for="(
                                    competence, competenceIndex
                                  ) in levelGroup"
                                >
                                  <div
                                    :key="`level-competence-${competence.id}`"
                                    class="competence-group"
                                    style="
                                      background-color: #f0f0f0;
                                      border-radius: 10px;
                                    "
                                  >
                                    <b-card-header
                                      header-tag="header"
                                      role="tab"
                                      class="competence-header"
                                      style="
                                        margin-bottom: 5px;
                                        justify-content: flex-start;
                                        align-items: center;
                                        gap: 10px;
                                        padding: 24px;
                                      "
                                      v-b-toggle="
                                        'accordion-competence-grouped-' +
                                        competence.id
                                      "
                                    >
                                      <div class="competence-content-wrapper">
                                        <div>
                                          <h3>
                                            {{ competence.user_sort_order }}
                                          </h3>
                                        </div>
                                        <div>
                                          <h6>
                                            <div v-if="competence.TematicUnit">
                                              <p
                                                style="
                                                  font-weight: bold;
                                                  margin-bottom: 0;
                                                  text-transform: uppercase;
                                                  padding-bottom: 5px;
                                                  font-size: 16px;
                                                "
                                              >
                                                <strong
                                                  >Unidade Temática:</strong
                                                >
                                                {{
                                                  competence.TematicUnit
                                                    .description
                                                }}
                                              </p>
                                            </div>
                                            <div>
                                              <p
                                                style="
                                                  font-weight: normal;
                                                  margin-bottom: 0;
                                                  font-size: 16px;
                                                "
                                              >
                                                <strong>Competência:</strong>
                                                {{ competence.description }}
                                              </p>
                                            </div>
                                          </h6>
                                        </div>
                                      </div>
                                    </b-card-header>

                                    <b-collapse
                                      :id="
                                        'accordion-competence-grouped-' +
                                        competence.id
                                      "
                                      role="tabpanel"
                                    >
                                      <div class="competence-content">
                                        <button
                                          style="margin-bottom: 5px"
                                          :class="
                                            areAllTopicsFromCompetenceAdded(
                                              competence.id
                                            )
                                              ? 'btn-remove-all-topics'
                                              : 'btn-add-all-topics'
                                          "
                                          @click="
                                            addAllTopicsFromCompetences(
                                              competence.id
                                            )
                                          "
                                        >
                                          {{
                                            areAllTopicsFromCompetenceAdded(
                                              competence.id
                                            )
                                              ? `Desmarcar todos da
                                          unidade
                                          temática`
                                              : "Selecionar todos da unidade temática"
                                          }}
                                        </button>

                                        <ul
                                          class="list-competence"
                                          style="padding-left: 0px"
                                        >
                                          <li
                                            v-for="(
                                              topics, indexTopic
                                            ) in competence.Topics"
                                            :key="topics.id"
                                          >
                                            <p
                                              v-if="
                                                !topicsSelected.find(
                                                  (selected) =>
                                                    selected.id === topics.id
                                                )
                                              "
                                            >
                                              <span
                                                v-if="topics.KnowledgeObject"
                                              >
                                                <strong
                                                  ><span
                                                    >{{
                                                      competence.user_sort_order
                                                    }}.{{
                                                      topics.sort_order
                                                    }}</span
                                                  >
                                                  Objeto de
                                                  Conhecimento:</strong
                                                >
                                                {{
                                                  topics.KnowledgeObject
                                                    .description
                                                }}
                                                <br />
                                                <strong>Conteúdo:</strong>
                                                {{ topics.description }}
                                              </span>
                                              <span v-else>
                                                <strong
                                                  ><span
                                                    >{{
                                                      competence.user_sort_order
                                                    }}.{{
                                                      topics.sort_order
                                                    }}</span
                                                  >
                                                  Conteúdo:</strong
                                                >
                                                {{ topics.description }}
                                              </span>
                                            </p>
                                            <p
                                              v-else
                                              class="list-competence-selected"
                                            >
                                              <span
                                                v-if="topics.KnowledgeObject"
                                              >
                                                <strong
                                                  ><span
                                                    >{{
                                                      competence.user_sort_order
                                                    }}.{{
                                                      topics.sort_order
                                                    }}</span
                                                  >
                                                  Objeto de
                                                  Conhecimento:</strong
                                                >
                                                {{
                                                  topics.KnowledgeObject
                                                    .description
                                                }}
                                                <br />
                                                <strong>Conteúdo:</strong>
                                                {{ topics.description }}
                                              </span>
                                              <span v-else>
                                                <strong
                                                  ><span
                                                    >{{
                                                      competence.user_sort_order
                                                    }}.{{
                                                      topics.sort_order
                                                    }}</span
                                                  >
                                                  Conteúdo:</strong
                                                >
                                                {{ topics.description }}
                                              </span>
                                            </p>
                                            <span
                                              v-if="
                                                !topicsSelected.find(
                                                  (selected) =>
                                                    selected.id === topics.id
                                                )
                                              "
                                              class="btn-plus"
                                              @click="
                                                addTopics(
                                                  topics,
                                                  competence.user_sort_order ||
                                                    competence.sort_order +
                                                      '.' +
                                                      topics.sort_order,
                                                  indexTopic,
                                                  competenceIndex
                                                )
                                              "
                                            >
                                              +
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </b-collapse>
                                  </div>
                                </template>
                              </b-collapse>
                            </div>
                          </b-collapse>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="col students-list">
                    <p class="bold">
                      Alunos
                      {{
                        studentsForCycle.length > 0
                          ? `(${studentsForCycle.length})`
                          : ""
                      }}
                    </p>
                    <div class="col-content">
                      <p class="about">
                        Clique no(s) aluno(s) que deseja inserir na competência
                        selecionada.
                      </p>
                      <p
                        class="about"
                        style="font-size: 12px; color: #666; margin-top: 5px"
                      >
                        <strong>Nota:</strong> Alguns alunos podem estar em
                        outros ciclos, mas aparecem nesta lista porque em seu
                        histórico foram encontrados conteúdos da versão do ciclo
                        selecionado.
                      </p>
                      <div class="wrap-search-students">
                        <form @submit.prevent="search">
                          <b-form-group>
                            <div
                              class="d-flex justify-content-between align-items-center mb-2"
                            >
                              <label class="mb-0">Buscar alunos </label>
                              <b-button
                                size="sm"
                                class="btn-add-all-topics"
                                style="margin-bottom: 0; font-weight: normal"
                                v-if="
                                  this.subject > 0 &&
                                  this.typeId === 2 &&
                                  filteredStudentList.length
                                "
                                @click="addAllFilteredStudents"
                              >
                                Adicionar Todos
                              </b-button>
                            </div>

                            <b-input-group>
                              <b-form-input
                                v-model="searchStudentList"
                                type="search"
                                placeholder="Buscar por aluno"
                              />
                              <b-input-group-append
                                v-if="searchStudentList !== ''"
                              >
                                <b-button
                                  variant="light"
                                  class="clear-fields"
                                  v-b-tooltip.hover
                                  title="Limpar Pesquisa"
                                  @click="clearStudentList"
                                >
                                  <b-icon icon="x"></b-icon>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </form>
                      </div>

                      <div v-if="loadingStudents" class="text-center py-3">
                        <b-spinner small></b-spinner>
                        <span class="ml-2">Carregando alunos...</span>
                      </div>

                      <span
                        class="empty-student-list"
                        v-else-if="this.filteredStudentList.length <= 0"
                        >Nenhum aluno encontrado.</span
                      >
                      <ul v-else-if="this.filteredStudentList.length > 0">
                        <li
                          v-for="(item, index) in this.filteredStudentList"
                          :key="`student-${index}`"
                          @click="selectStudent(item)"
                        >
                          <div class="img-student">
                            <figure
                              :style="{
                                backgroundImage: 'url(' + item.User.photo + ')',
                              }"
                            >
                              <span>
                                <ArrowUpStudents />
                              </span>
                            </figure>
                          </div>
                          <div class="info-studante">
                            <span>{{ item.User.name }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-container>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import SelectSimple from "@/components/inputs/SelectSimple.vue";
import ArrowUpStudents from "@/components/svg/ArrowUpStudents";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon";
import RateIcon from "@/components/svg/RateIcon.vue";
import ViewIcon from "@/components/svg/ViewIcon2.vue";
import DataServiceClassrooms from "@/services/classrooms.service";
import { mapGetters, mapMutations } from "vuex";
import httpRda from "../../http-rda";
export default {
  name: "OldTutoringCollective",
  components: {
    SelectSimple,
    RateIcon,
    LeftArrowIcon,
    ViewIcon,
    Accordion,
    ArrowUpStudents,
  },

  data() {
    return {
      classroomsSelAux: [],
      classroomsSel: [],
      selectedClassroomsSel: [],
      canOverwriteTopics: false,
      isFutureTopics: false,
      isGrouped: false,
      wasRequestMade: false,
      cycle: null,
      cycle_id: 1,
      subject: null,
      progress: null,
      loading: false,
      currentPage: 1,
      statusSelected: null,
      count: 0,
      perPage: 20,
      typeId: null,
      learningStatus: ["EE", "AN", "A", "*", "#", ""],
      selectedCycle: null,
      selectedCycleAux: null,
      listSubjects: [],
      selectedDisciplinary: null,
      selectedDisciplinaryAux: null,
      breadcrumb: [
        {
          text: "Registros Antigos",
          href: "/alunos-registros-antigos",
        },
        {
          text: "Lançamento Coletivo",
          href: "/alunos-registros-antigos/lancamento-coletivo",
          active: true,
        },
      ],
      students: [],
      searchStudentList: "",
      topicsSelected: [],
      studentsForCycle: [],
      studentsSelected: [],
      competencesList: [],
      allCycles: [],
      versionOptions: [],
      selectedVersion: null,
      loadingVersions: false,
      loadingCycles: false,
      loadingClassrooms: false,
      loadingSubjects: false,
      loadingStudents: false,
    };
  },

  filters: {
    date(date) {
      try {
        var d = new Date(date.split());
        var year = d.getFullYear().toString().substr(-2);
        var month = (d.getMonth() + 1).toString().padStart(2, "0");
        var day = d.getUTCDate().toString().padStart(2, "0");

        return day + "/" + month + "/" + year;
      } catch (error) {
        return date;
      }
    },
  },

  mounted() {
    this.userUpdateTopicPermission();
    this.getVersions();
    this.getCycles();
    this.getClassrooms();
    this.typeId = 2;
  },

  created() {
    if (this.selectedCycleAux != null) {
      this.selectCycle(JSON.parse(this.selectedCycleAux));
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
    }),

    hasLanguageCompetences() {
      return this.competencesList.every(
        (competence) => !competence.modality && competence.details
      );
    },

    groupedByModalityAndLevel() {
      return (competences) => {
        const grouped = {};
        let competenceSortOrderLevel = 1;

        competences.forEach((competence) => {
          if (competence.modality) {
            if (!grouped[competence.modality]) {
              grouped[competence.modality] = {};
              competenceSortOrderLevel = 1;
            }
            const level = competence.details || "Sem Nível";
            if (!grouped[competence.modality][level]) {
              grouped[competence.modality][level] = [];
            }
            grouped[competence.modality][level].push({
              ...competence,
              user_sort_order: competenceSortOrderLevel,
            });

            const compAux = this.competencesList.find(
              (c) => c.id === competence.id
            );
            if (compAux) {
              compAux.user_sort_order = competenceSortOrderLevel;
            }

            competenceSortOrderLevel++;
          } else if (competence.details) {
            const subjectName = this.selectedDisciplinary
              ? this.selectedDisciplinary.label
              : "Idioma";

            if (!grouped[subjectName]) {
              grouped[subjectName] = {};
              competenceSortOrderLevel = 1;
            }

            const level = competence.details;
            if (!grouped[subjectName][level]) {
              grouped[subjectName][level] = [];
            }

            grouped[subjectName][level].push({
              ...competence,
              user_sort_order: competenceSortOrderLevel,
            });

            const compAux = this.competencesList.find(
              (c) => c.id === competence.id
            );
            if (compAux) {
              compAux.user_sort_order = competenceSortOrderLevel;
            }

            competenceSortOrderLevel++;
          }
        });

        return grouped;
      };
    },

    isCoordinator() {
      if (this.currentUser && this.currentUser.role) {
        return (
          this.currentUser.role.includes("coordinator") ||
          this.currentUser.role.includes("admin")
        );
      }

      return false;
    },

    subjectsSel() {
      return this.listSubjects;
    },

    filteredStudentList() {
      return this.studentsForCycle.filter((item) => {
        let name = item.User.name.toLowerCase();
        name = name.replace(/[aáàãäâ]/, "a");
        name = name.replace(/[eéèëê]/, "e");
        name = name.replace(/[iíìïî]/, "i");
        name = name.replace(/[oóòõöô]/, "o");
        name = name.replace(/[uúùüû]/, "u");
        return name.includes(this.searchStudentList.toLowerCase());
      });
    },

    topicsGroupedByTematicUnit() {
      const groupedTopics = {};

      this.topicsSelected.forEach((topic, index) => {
        const tematicUnitId = topic.TematicUnit
          ? topic.TematicUnit.id
          : "no-unit";

        if (!groupedTopics[tematicUnitId]) {
          groupedTopics[tematicUnitId] = {
            tematicUnit: topic.TematicUnit,
            competenceModality: topic.competenceModality || null,
            competenceDetails: topic.competenceDetails || null,
            competenceDescription: topic.competenceDescription || null,
            topics: [],
          };
        }

        groupedTopics[tematicUnitId].topics.push({
          ...topic,
          id: topic.id,
          originalIndex: index,
          sortOrder: topic.sortOrder,
        });
      });

      return Object.values(groupedTopics);
    },
  },

  methods: {
    ...mapMutations({
      resetStudents: "learning/RESET_STUDENTS_BY_SUBJECT",
    }),

    async callbackClassrooms({ id }) {
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.selectedClassroomsSel.push(id);
      await this.getStudents(this.isFutureTopics);
    },

    async callbackRemoveClassrooms({ id }) {
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.selectedClassroomsSel = this.selectedClassroomsSel.filter(
        (classroom) => classroom !== id
      );
      await this.getStudents(this.isFutureTopics);
    },

    async getVersions() {
      this.loadingVersions = true;
      try {
        const response = await httpRda.get("/tutoring-old-curriculum/versions");
        this.versionOptions = response.data.result.map((version) => ({
          id: version.id,
          label: version.label,
        }));
      } catch (error) {
        this.versionOptions = [];
      } finally {
        this.loadingVersions = false;
      }
    },

    selectVersion(value) {
      this.selectedVersion = value;
      this.selectedCycle = null;
      this.classroomsSelAux = [];
      this.selectedClassroomsSel = [];
      this.listSubjects = [];
      this.selectedDisciplinary = null;
      this.topicsSelected = [];
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.competencesList = [];
      this.getCycles();
    },

    userUpdateTopicPermission() {
      httpRda
        .get("updateTopicUser/" + this.currentUser.id)
        .then((res) => {
          this.canOverwriteTopics = res.data.result;
        })
        .catch(() => {
          this.canOverwriteTopics = false;
        });
    },

    groupedLanguagesByLevel(competences) {
      const grouped = {};
      competences.forEach((competence) => {
        if (competence.details) {
          const level = competence.details;
          if (!grouped[level]) {
            grouped[level] = [];
          }
          grouped[level].push({
            ...competence,
          });
        }
      });
      return grouped;
    },

    areAllTopicsFromLanguageLevelAdded(levelName) {
      const levelGroup = this.groupedLanguagesByLevel(
        this.competencesWithDetailsOnly(this.competencesList)
      )[levelName];

      if (!levelGroup) {
        return false;
      }

      return levelGroup.every((competence) =>
        competence.Topics.every((topic) =>
          this.topicsSelected.some((selected) => selected.id === topic.id)
        )
      );
    },

    addAllTopicsFromLanguageLevel(levelName) {
      const levelGroup = this.groupedLanguagesByLevel(
        this.competencesWithDetailsOnly(this.competencesList)
      )[levelName];

      if (!levelGroup) {
        return;
      }

      const allTopicsAdded = this.areAllTopicsFromLanguageLevelAdded(levelName);

      if (allTopicsAdded) {
        this.removeAllTopicsFromLanguageLevel(levelName);
      } else {
        levelGroup.forEach((competence) => {
          competence.Topics.forEach((topic, indexTopic) => {
            topic.competence_id = competence.id;
            const competenceIndex = this.competencesList.findIndex(
              (c) => c.id === competence.id
            );
            const competenceSortOrder =
              competence.user_sort_order || competence.sort_order;

            this.addTopics(
              topic,
              competenceSortOrder + "." + topic.sort_order,
              indexTopic,
              competenceIndex
            );
          });
        });
      }
    },
    removeAllTopicsFromLanguageLevel(levelName) {
      const levelGroup = this.groupedLanguagesByLevel(
        this.competencesWithDetailsOnly(this.competencesList)
      )[levelName];

      if (!levelGroup) {
        return;
      }

      levelGroup.forEach((competence) => {
        const topics = competence.Topics;
        this.topicsSelected = this.topicsSelected.filter(
          (selected) => !topics.some((topic) => topic.id === selected.id)
        );
      });
    },
    areAllTopicsFromLevelAdded(modalityName, levelName) {
      const modalityLevels = this.groupedByModalityAndLevel(
        this.competencesList
      );
      const levelGroup =
        modalityLevels[modalityName] && modalityLevels[modalityName][levelName];

      if (!levelGroup) {
        return false;
      }

      return levelGroup.every((competence) =>
        competence.Topics.every((topic) =>
          this.topicsSelected.some((selected) => selected.id === topic.id)
        )
      );
    },

    addAllTopicsFromLevel(modalityName, levelName) {
      const modalityLevels = this.groupedByModalityAndLevel(
        this.competencesList
      );
      const levelGroup =
        modalityLevels[modalityName] && modalityLevels[modalityName][levelName];

      if (!levelGroup) {
        return;
      }

      const allTopicsAdded = this.areAllTopicsFromLevelAdded(
        modalityName,
        levelName
      );

      if (allTopicsAdded) {
        this.removeAllTopicsFromLevel(modalityName, levelName);
      } else {
        levelGroup.forEach((competence) => {
          competence.Topics.forEach((topic, indexTopic) => {
            topic.competence_id = competence.id;
            const competenceIndex = this.competencesList.findIndex(
              (c) => c.id === competence.id
            );
            const competenceSortOrder =
              competence.user_sort_order || competence.sort_order;

            this.addTopics(
              topic,
              competenceSortOrder + "." + topic.sort_order,
              indexTopic,
              competenceIndex
            );
          });
        });
      }
    },

    removeAllTopicsFromLevel(modalityName, levelName) {
      const modalityLevels = this.groupedByModalityAndLevel(
        this.competencesList
      );
      const levelGroup =
        modalityLevels[modalityName] && modalityLevels[modalityName][levelName];

      if (!levelGroup) {
        return;
      }

      levelGroup.forEach((competence) => {
        const topics = competence.Topics;
        this.topicsSelected = this.topicsSelected.filter(
          (selected) => !topics.some((topic) => topic.id === selected.id)
        );
      });
    },

    areAllTopicsFromModalityAdded(modalityName) {
      const modalityLevels = this.groupedByModalityAndLevel(
        this.competencesList
      );
      const modalityData = modalityLevels[modalityName];

      if (!modalityData) {
        return false;
      }

      return Object.values(modalityData).every((levelGroup) =>
        levelGroup.every((competence) =>
          competence.Topics.every((topic) =>
            this.topicsSelected.some((selected) => selected.id === topic.id)
          )
        )
      );
    },

    addAllTopicsFromModality(modalityName) {
      const modalityLevels = this.groupedByModalityAndLevel(
        this.competencesList
      );
      const modalityData = modalityLevels[modalityName];

      if (!modalityData) {
        return;
      }

      const allTopicsAdded = this.areAllTopicsFromModalityAdded(modalityName);

      if (allTopicsAdded) {
        this.removeAllTopicsFromModality(modalityName);
      } else {
        Object.values(modalityData).forEach((levelGroup) => {
          levelGroup.forEach((competence) => {
            competence.Topics.forEach((topic, indexTopic) => {
              topic.competence_id = competence.id;
              const competenceIndex = this.competencesList.findIndex(
                (c) => c.id === competence.id
              );
              const competenceSortOrder =
                competence.user_sort_order || competence.sort_order;

              this.addTopics(
                topic,
                competenceSortOrder + "." + topic.sort_order,
                indexTopic,
                competenceIndex
              );
            });
          });
        });
      }
    },

    removeAllTopicsFromModality(modalityName) {
      const modalityLevels = this.groupedByModalityAndLevel(
        this.competencesList
      );
      const modalityData = modalityLevels[modalityName];

      if (!modalityData) {
        return;
      }

      Object.values(modalityData).forEach((levelGroup) => {
        levelGroup.forEach((competence) => {
          const topics = competence.Topics;
          this.topicsSelected = this.topicsSelected.filter(
            (selected) => !topics.some((topic) => topic.id === selected.id)
          );
        });
      });
    },

    getLevelId(modalityName, levelName) {
      return `${this.getModalityId(modalityName)}-${levelName
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}`;
    },

    competencesWithoutModality(competences) {
      return competences.filter(
        (competence) => !competence.modality && !competence.details
      );
    },

    competencesWithDetailsOnly(competences) {
      return competences.filter(
        (competence) => !competence.modality && competence.details
      );
    },

    getModalityId(modalityName) {
      return modalityName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    },

    clearFields() {
      this.currentPage = 1;
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.topicsSelected = [];
      this.classroomsSelAux = [];
      this.selectedClassroomsSel = [];
    },

    callbackCycles({ id }) {
      this.cycle = id !== -1 ? id : null;
      this.currentPage = 1;
      this.clearSubject();
    },

    clearCycles() {
      this.cycle = null;
      this.currentPage = 1;
      this.clearSubject();
    },

    clearStudentList() {
      this.searchStudentList = "";
    },

    clearSubject() {
      this.subject = null;
      this.currentPage = 1;
      this.wasRequestMade = false;
      this.competencesList = [];
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.topicsSelected = [];
      this.resetStudents();
      this.selectedCycle = null;
      this.listSubjects = [];
      this.students = [];
      this.classroomsSelAux = [];
      this.cycle = null;
      this.selectedCycleAux = null;
      this.selectedDisciplinaryAux = null;
    },

    async selectYearEq() {
      this.page = 1;
      this.topicsSelected = [];
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.getSubjects();
    },

    async removeYearEq() {
      this.page = 1;
      this.topicsSelected = [];
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.getSubjects();
    },

    clearYearEq(justClear = false) {
      this.page = 1;
      if (!justClear) {
        this.getSubjects();
      }
    },

    async getSubjects() {
      if (this.subject) {
        this.loadingSubjects = true;
        try {
          const params = {
            include: "topics",
          };

          if (this.selectedVersion) {
            params.version = this.selectedVersion.id;
          }

          const subjects = await httpRda.get("subjects/" + this.subject, {
            params,
          });

          await this.getStudents(this.isFutureTopics);

          this.count = subjects.data.count;
          this.wasRequestMade = true;
          let competences = subjects.data.subject.Competences;

          this.isGrouped =
            Object.keys(this.groupedByModalityAndLevel(competences)).length > 0;
          this.competencesList = competences;
        } catch (error) {
          this.competencesList = [];
          this.studentsForCycle = [];
          this.wasRequestMade = false;

          this.$swal.fire({
            title: "Atenção",
            text: "Não foram encontrados conteúdos para a área do conhecimento selecionada nessa versão do currículo.",
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          });
        } finally {
          this.loadingSubjects = false;
        }
      }
    },

    async getStudents() {
      if (!this.selectedCycle || !this.subject) {
        this.studentsForCycle = [];
        return;
      }

      this.loadingStudents = true;
      try {
        const params = {
          oldRecords: 1,
        };
        if (this.selectedVersion) {
          params.version = this.selectedVersion.id;
        }

        if (this.selectedClassroomsSel.length > 0) {
          params.classrooms = this.selectedClassroomsSel;
        }

        if (this.selectedCycle) {
          params.cycleId = this.selectedCycle.id;
        }

        const response = await httpRda.get(
          `tutoring-old-curriculum/subjects/${this.subject}/students`,
          { params }
        );

        const students = response.data.result.map((student) => ({
          id: student.student_id,
          User: {
            name: student.name,
            photo: student.photo,
          },
        }));

        const selectedIds = this.studentsSelected.map((s) => s.id);

        this.studentsForCycle = students.filter(
          (student) => !selectedIds.includes(student.id)
        );
      } catch (error) {
        this.studentsForCycle = [];
      } finally {
        this.loadingStudents = false;
      }
    },

    async getCycles() {
      if (!this.selectedVersion) {
        this.allCycles = [];
        this.selectedCycle = null;
        return;
      }

      this.loadingCycles = true;
      try {
        const cycles = await httpRda.get(
          `tutoring-old-curriculum/cycles?version=${this.selectedVersion.id}`
        );
        const filter = cycles.data.result.map((item) => {
          item.label = item.designation;
          delete item.designation;
          return item;
        });
        this.allCycles = filter;
      } catch (error) {
        this.allCycles = [];
      } finally {
        this.loadingCycles = false;
      }
    },

    getClassrooms(cycleId = null) {
      this.loadingClassrooms = true;
      DataServiceClassrooms.index({
        yearsback: 0,
        cycleId: cycleId,
        oldRecords: 1,
      })
        .then((response) => {
          this.classroomsSel = response.data.classrooms;
          if (this.classroomsSel.length) {
            this.classroomsSel = this.classroomsSel.map((classroom) => {
              return {
                id: classroom.id,
                designation: classroom.designation,
                calendar_id: classroom.calendar_id,
              };
            });
          }
        })
        .catch((error) => {
          return error.data;
        })
        .finally(() => {
          this.loadingClassrooms = false;
        });
    },

    async selectCycle(params) {
      this.selectedClassroomsSel = [];
      this.classroomsSelAux = [];

      if (this.selectedCycleAux !== params.id) {
        this.currentPage = 1;
      }

      this.listSubjects = [];
      this.selectedCycle = params;
      this.loadingSubjects = true;

      const queryParams = {};

      if (this.selectedVersion) {
        queryParams.version = this.selectedVersion.id;
      }

      try {
        await this.getClassrooms(this.selectedCycle.id);

        let response = await httpRda.get(
          `tutoring-old-curriculum/cycles/${params.id}/subjects`,
          {
            params: queryParams,
          }
        );

        let subjects = response.data.result;

        subjects = subjects
          .map((item) => {
            item.label = item.designation;
            delete item.designation;
            return item;
          })
          .sort((a, b) => a.label.localeCompare(b.label));

        this.listSubjects = subjects;

        this.studentsSelected = [];
        this.studentsForCycle = [];
        this.topicsSelected = [];
        this.competencesList = [];

        if (
          this.selectedDisciplinaryAux == null ||
          this.selectedDisciplinaryAux.cycle_id !== params.id
        ) {
          this.selectedDisciplinaryAux = null;
          this.selectedDisciplinary = null;
        }

        if (subjects.length > 0) {
          if (this.selectedDisciplinaryAux != null) {
            this.subject = this.selectedDisciplinaryAux.id;
            await this.getSubjects();
            this.selectedDisciplinary = this.selectedDisciplinaryAux;
          }
        } else {
          this.students = [];
          this.subject = null;
        }
      } finally {
        this.loadingSubjects = false;
      }
    },

    async selectDisciplinary(params) {
      this.topicsSelected = [];
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.selectedDisciplinary = params;
      this.subject = params.id;
      this.selectedDisciplinaryAux = params;

      await this.getSubjects();
    },

    selectSubject(value) {
      this.topicsSelected = [];
      this.studentsSelected = [];
      this.studentsForCycle = [];
      this.subject = value.id;
      this.getSubjects();
      this.wasRequestMade = true;
    },

    normalizeString(str) {
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },

    formatDateToUs(date) {
      return new Intl.DateTimeFormat("ko-KR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
        .format(new Date(date))
        .replaceAll(". ", "/")
        .replace(".", "");
    },

    selectStatus(status) {
      this.statusSelected = status;
    },
    cleanStatus() {
      this.statusSelected = "";
    },

    removeTopics(id) {
      const index = this.topicsSelected.findIndex((topic) => topic.id === id);
      if (index !== -1) {
        this.topicsSelected.splice(index, 1);
      }
    },

    selectStudent(student) {
      const alreadySelected = this.studentsSelected.some(
        (s) => s.id === student.id
      );
      if (!alreadySelected) {
        this.studentsSelected.push(student);
      }

      this.studentsForCycle = this.studentsForCycle.filter(
        (s) => s.id !== student.id
      );

      this.studentsSelected.sort((a, b) => {
        if (a.User.name < b.User.name) return -1;
        if (a.User.name > b.User.name) return 1;
        return 0;
      });
    },

    removeStudent(index, student) {
      this.studentsSelected.splice(index, 1);
      this.studentsForCycle.push(student);

      const uniqueById = {};
      this.studentsForCycle.forEach((s) => {
        uniqueById[s.id] = s;
      });
      this.studentsForCycle = Object.values(uniqueById);

      this.studentsForCycle.sort((a, b) => {
        if (a.User.name < b.User.name) return -1;
        if (a.User.name > b.User.name) return 1;
        return 0;
      });
    },

    addAllFilteredStudents() {
      const allStudents = [
        ...this.studentsSelected,
        ...this.filteredStudentList,
      ];

      const uniqueById = {};
      allStudents.forEach((student) => {
        uniqueById[student.id] = student;
      });
      this.studentsSelected = Object.values(uniqueById);

      this.studentsSelected.sort((a, b) => {
        if (a.User.name < b.User.name) return -1;
        if (a.User.name > b.User.name) return 1;
        return 0;
      });

      const filteredIds = this.filteredStudentList.map((s) => s.id);
      this.studentsForCycle = this.studentsForCycle.filter(
        (s) => !filteredIds.includes(s.id)
      );
    },

    removeAllStudents() {
      this.studentsForCycle = [
        ...this.studentsForCycle,
        ...this.studentsSelected,
      ];

      const uniqueById = {};
      this.studentsForCycle.forEach((student) => {
        uniqueById[student.id] = student;
      });
      this.studentsForCycle = Object.values(uniqueById);

      this.studentsForCycle.sort((a, b) => {
        if (a.User.name < b.User.name) return -1;
        if (a.User.name > b.User.name) return 1;
        return 0;
      });
      this.studentsSelected = [];
    },

    addTopics(topic, topicIndex, indexTopic, competenceIndex) {
      if (!this.topicsSelected.find((selected) => selected.id === topic.id)) {
        let competence = null;

        if (topic.competence_id) {
          competence = this.competencesList.find(
            (comp) => comp.id === topic.competence_id
          );
        }

        if (!competence && typeof competenceIndex === "number") {
          competence = this.competencesList[competenceIndex];
        }

        const originalSortOrder = competence
          ? `${competence.user_sort_order || competence.sort_order}.${
              topic.sort_order
            }`
          : topicIndex;

        const topicsObject = {
          id: topic.id,
          name: topic.name,
          description: topic.description,
          sortOrder: originalSortOrder,
          original_sort_order: topic.sort_order,
          competences: topic.competences,
          competence_id: competence ? competence.id : null,
          KnowledgeObject: topic.KnowledgeObject,
          TematicUnit:
            competence && competence.TematicUnit
              ? competence.TematicUnit
              : null,
          competenceDescription: competence ? competence.description : null,
          competenceModality: competence ? competence.modality : null,
          competenceDetails: competence ? competence.details : null,
        };
        this.topicsSelected.push(topicsObject);
      }
    },

    addAllTopicsFromCompetences(competenceId) {
      const competence = this.competencesList.find(
        (comp) => comp.id === competenceId
      );
      if (!competence) {
        return;
      }

      if (this.areAllTopicsFromCompetenceAdded(competenceId)) {
        this.removeAllTopicsFromCompetence(competenceId);
      } else {
        const topics = competence.Topics;
        topics.forEach((topic, indexTopic) => {
          topic.competence_id = competenceId;

          const competenceIndex = this.competencesList.findIndex(
            (c) => c.id === competenceId
          );
          const competenceSortOrder =
            competence.user_sort_order || competence.sort_order;

          this.addTopics(
            topic,
            competenceSortOrder + "." + topic.sort_order,
            indexTopic,
            competenceIndex
          );
        });
      }
    },

    addAllTopics() {
      if (this.topicsSelected.length > 0) {
        this.topicsSelected = [];
        return;
      }

      this.competencesList.forEach((competence) => {
        this.addAllTopicsFromCompetences(competence.id);
      });
    },

    areAllTopicsFromCompetenceAdded(competenceId) {
      const competence = this.competencesList.find(
        (comp) => comp.id === competenceId
      );
      if (!competence) {
        return false;
      }

      const topics = competence.Topics;
      return topics.every((topic) =>
        this.topicsSelected.some((selected) => selected.id === topic.id)
      );
    },

    removeAllTopicsFromCompetence(competenceId) {
      const competence = this.competencesList.find(
        (comp) => comp.id === competenceId
      );
      if (!competence) {
        return;
      }

      const topics = competence.Topics;
      this.topicsSelected = this.topicsSelected.filter(
        (selected) => !topics.some((topic) => topic.id === selected.id)
      );
    },

    removeAllTopics() {
      this.topicsSelected = [];
    },

    async register() {
      try {
        const evaluation = this.statusSelected;

        const topics = this.topicsSelected.map((item) => item.id);
        const students = this.studentsSelected.map((item) => item.id);

        if (evaluation === null) {
          this.$swal.fire({
            title: "Atenção",
            text: "Selecione um status para registrar.",
            icon: "warning",
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
        if (this.canOverwriteTopics) {
          const overwriteA = await this.$swal.fire({
            title: "Deseja sobrescrever os status 'A' dos alunos selecionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#68c5b7",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
          });

          const overwriteAsterisk = await this.$swal.fire({
            title: "Deseja sobrescrever os status '*' dos alunos selecionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#68c5b7",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
          });

          await this.sendRegisterRequest({
            evaluation,
            topics,
            students,
            overwriteA: overwriteA.isConfirmed,
            overwriteAsterisk: overwriteAsterisk.isConfirmed,
          });
        } else {
          await this.sendRegisterRequest({
            evaluation,
            topics,
            students,
            overwriteA: false,
            overwriteAsterisk: false,
          });
        }
      } catch (error) {
        this.$swal.fire({
          title: "Alerta",
          text: "Não foi possível registrar.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    async sendRegisterRequest(data) {
      try {
        const response = await httpRda.patch("studentstopicsupdate", {
          evaluation: data.evaluation,
          topics: data.topics,
          students: data.students,
          overwriteA: data.overwriteA || false,
          overwriteAsterisk: data.overwriteAsterisk || false,
        });

        const {
          successfulUpdates = [],
          failedUpdates = [],
          successfulUpdatesGrouped = {},
          failedUpdatesGrouped = {},
          msg,
        } = response.data;

        if (failedUpdates.length > 0 && successfulUpdates.length > 0) {
          this.$swal.fire({
            title: "Atenção",
            html: `
                  <p><strong>Atualizações bem-sucedidas:</strong></p>
                  <ul>
                    ${Object.entries(successfulUpdatesGrouped)
                      .map(
                        ([aluno, quantidade]) =>
                          `<li>${aluno}: ${quantidade}</li>`
                      )
                      .join("")}
                  </ul>

                  <p><strong>Atualizações não realizadas! Procurar a direção pedagógica.</strong></p>
                  <ul>
                    ${Object.entries(failedUpdatesGrouped)
                      .map(
                        ([aluno, quantidade]) =>
                          `<li>${aluno}: ${quantidade}</li>`
                      )
                      .join("")}
                  </ul>
                `,
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          });
        } else if (failedUpdates.length > 0) {
          this.$swal.fire({
            title: "Atenção",
            text: "Essa ação não pode ser realizada! Procure a direção Pedagógica.",
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (successfulUpdates.length > 0) {
          this.$swal.fire({
            title: "Sucesso!",
            text: msg || "Atualizações realizadas com sucesso.",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.$swal.fire({
            title: "Atenção",
            text: "Nenhuma atualização foi realizada.",
            icon: "warning",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          });
        }

        this.topicsSelected = [];
        this.statusSelected = null;
      } catch (error) {
        this.$swal.fire({
          title: "Alerta",
          text: error.response.data.message || "Não foi possível registrar.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },

  watch: {
    currentPage() {
      this.getSubjects();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },

  destroyed() {
    this.resetStudents();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 82px;
  padding: 10px 15px;
  color: #6c757d;
}

.alignTextBox {
  text-align: center;

  p {
    margin: 0;
  }
}

.home {
  height: 100%;
}

.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}

.progress {
  border-radius: 30px;
  height: 7px;

  .progress-bar {
    background-color: $purple;
  }

  &.orange {
    .progress-bar {
      background-color: $orange2;
    }
  }

  &.yellow {
    .progress-bar {
      background-color: $yellow;
    }
  }

  &.red {
    .progress-bar {
      background-color: $red;
    }
  }

  &.green {
    .progress-bar {
      background-color: $green2;
    }
  }
}

.container-rda {
  padding-bottom: 0;
}

.learning-date {
  background-color: $purple;
  border-radius: 6px;
  color: $white;
  line-height: 28px;
  max-width: 82px;
  text-align: center;
  width: 100%;
}

.boxStatus {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  p {
    margin: 10px;
  }
}

.statusButton {
  background-color: $grey5;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: $white;
  font-size: 18px;
  line-height: 28px;
  width: 34px;
  height: 34px;
  text-align: center;
  cursor: pointer;

  &.active {
    background-color: $blue;
  }
}

.list-page {
  .list-teacher:hover {
    cursor: unset;
  }

  .list-actions {
    padding: 10px 0;
    cursor: pointer;

    .evaluation:not(.evaluated) path {
      fill: gray;
    }
  }
}

.inactive {
  filter: grayscale(1);
}

.empty-content {
  font-size: 18px;
  text-align: center;
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;

  b {
    color: #b23066;
  }
}

.wrap-competence {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 0;

  .container-fluid {
    margin-left: -15px;
    margin-right: -15px;
  }

  .box-content {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 7px;
    row-gap: 15px;
    margin-right: -15px;
    margin-left: -15px;
    box-sizing: border-box;

    .col {
      .col-content {
        background: #fff;
        border: 1px solid #b3b3b3;
        border-radius: 10px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        row-gap: 24px;
        margin-bottom: 10px;
        height: max-content;
      }

      &.list {
        flex-grow: 2.5;
      }
    }
  }

  .list-competence {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 9px;

    li {
      width: 100%;
      border: 1px dashed transparent;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 13px;
      box-sizing: border-box;
      border-radius: 4px;
      cursor: pointer;

      &:hover,
      &:focus {
        border-color: #ccc;
      }

      &.selected {
        p {
          opacity: 0.4;
        }

        .btn-plus {
          color: #b3b3b3;
          background-color: #e6e6e6;
        }
      }

      p {
        flex: 1;
        color: #000;
        font-size: 18px;
        line-height: 20px;
        padding: 0;
        margin: 0;
      }

      .btn-plus {
        background: #68c5b7;
        color: #fff;
        font-size: 20px;
        line-height: 20px;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
      }
    }
  }

  .list-competence-selected {
    width: 100%;
    border: 1px dashed #b23066;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 5px !important;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    color: #b23066;
  }

  .btn-all-topics {
    background: #68c5b7;
    color: #fff;
    font-size: 20px;
    line-height: 20px;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: none;
  }

  .btn-all-topics-orange {
    background: #ef6549;
    color: #fff;
    font-size: 20px;
    line-height: 20px;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: none;
  }

  .students-list {
    .about {
      margin-bottom: 0;
    }

    form,
    fieldset {
      margin-bottom: 0;
    }

    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 15px;
      max-height: 300px;
      margin: 0;
      padding: 0;
      overflow-x: hidden;
      overflow-y: auto;

      li {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        list-style: none;
        box-sizing: border-box;
        cursor: pointer;

        &:hover {
          .img-student {
            figure {
              &:after {
                opacity: 1;
                transition: 0.1s all ease-in-out;
              }

              span {
                top: 0;
                opacity: 1;
                transition: 0.2s all ease-in-out;
                transition-delay: 0.1s;
              }
            }
          }
        }

        .img-student {
          width: 48px;
          height: 48px;

          figure {
            background-color: #ccc;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            width: inherit;
            height: inherit;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50px;
            overflow: hidden;
            position: relative;

            &:after {
              content: "";
              background: linear-gradient(
                0deg,
                rgba(178, 48, 102, 0.7),
                rgba(178, 48, 102, 0.7)
              );
              width: inherit;
              height: inherit;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 0;
              opacity: 0;
              transition: 0.1s all ease-in-out;
            }

            span {
              position: relative;
              top: 20px;
              z-index: 1;
              opacity: 0;
              transition: 0.2s all ease-in-out;
            }
          }
        }

        .info-studante {
          span {
            font-size: 18px;
            line-height: 24px;
          }
        }
      }
    }
  }

  .empty-student-list {
    text-align: center;
  }
}

.wrap-competence-selected {
  width: 100%;
  padding-top: 30px;

  .box-content {
    width: 100%;
    background: #fff;
    border: 1px solid #b3b3b3;
    border-radius: 10px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
  }

  .competence-items-selected {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    margin: 0;
    padding: 0;

    li {
      background-color: #f2f2f2;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 16px;
      list-style: none;

      .remove-item {
        background: #ef6549;
        color: #fff;
        font-size: 20px;
        line-height: 20px;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        position: relative;
        cursor: pointer;

        &:hover {
          transform: scale(1.1);
        }

        &:before {
          content: "";
          background: #fff;
          width: 10px;
          height: 2px;
          display: block;
        }
      }
    }
  }

  .students-items-selected {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 10px;
    row-gap: 10px;

    .img-student {
      width: 56px;
      height: 56px;
      cursor: pointer;

      &:hover {
        figure {
          &:after {
            opacity: 1;
            transition: 0.1s all ease-in-out;
          }

          span {
            top: 0;
            opacity: 1;
            transition: 0.2s all ease-in-out;
            transition-delay: 0.1s;
          }
        }
      }

      figure {
        background-color: #b3b3b3;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        width: inherit;
        height: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px;
        overflow: hidden;
        position: relative;

        &:after {
          content: "";
          background: linear-gradient(
            0deg,
            rgba(178, 48, 102, 0.7),
            rgba(178, 48, 102, 0.7)
          );
          width: inherit;
          height: inherit;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          opacity: 0;
          transition: 0.1s all ease-in-out;
        }

        span {
          position: relative;
          top: 20px;
          z-index: 1;
          opacity: 0;
          transition: 0.2s all ease-in-out;
          transform: rotate(-180deg);
        }
      }
    }
  }

  .wrap-btn-submit {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #d8d8d8;
    padding-top: 15px;

    button {
      width: 292px;
    }
  }
}

.btn-remove-all-topics {
  background: #ef6549;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 15px;
  border: none;
  margin-bottom: 16px;
}

.btn-add-all-topics {
  background: #68c5b7;
  color: #fff;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 0 15px;
  border: none;
  margin-bottom: 16px;
  transition: all 0.15s ease;

  &:hover {
    background: #57a9a1;
    color: #fff;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
}

.btn-remove-all-topics:hover {
  background: #d94c30;
}

.header-knowledge-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
}

.header-knowledge-field p {
  margin-bottom: 0;
}

.tematic-unit-header {
  margin-top: 10px;
  margin-bottom: 5px;
}

.modality-group {
  margin-bottom: 20px;
}

.modality-content {
  padding-left: 20px;
  border-left: 3px solid #6c757d;
  margin-left: 10px;
  background-color: #f8f9fa;
  border-radius: 0 5px 5px 0;
  padding-top: 10px;
  padding-bottom: 10px;
  row-gap: 0px !important;
}

::v-deep .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);

  h5 {
    margin: 0;
    cursor: pointer;
    color: #495057;
    font-weight: 600;

    &:hover {
      color: #007bff;
    }
  }
}

::v-deep .collapse {
  padding: 1rem;
  border: none !important;
}

.level-group {
  margin: 15px 0;
  padding-left: 10px;

  .modality-content {
    background-color: #f8f9fa;
  }
}

.competence-group {
  margin-bottom: 15px;
}

::v-deep .card-header {
  background-color: #f7f7f7;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);

  &.accordion-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.15s;

    &:hover {
      background-color: #e9ecef;
    }

    &:after {
      background: #868e96;
      display: block;
      content: "";
      -webkit-mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      -webkit-mask-size: cover;
      mask-size: cover;
      width: 20px;
      height: 20px;
      transition: all 0.15s;
      transform: rotate(0deg);
      flex-shrink: 0;
    }

    &[aria-expanded="true"]:after {
      transform: rotate(180deg);
    }
  }

  h5,
  h6 {
    margin: 0;
    color: #495057;
    font-weight: 600;
    pointer-events: none;

    &:hover {
      color: #495057;
    }
  }
}

.competence-header {
  background-color: #f7f7f7 !important;
  border: 1px solid #dee2e6 !important;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.15s;
  position: relative;
  justify-content: flex-start;

  h3 {
    color: #000 !important;
    transition: color 0.15s;
    margin: 0;
  }

  h6 {
    color: #000 !important;
    font-size: 14px;
    transition: color 0.15s;
    margin: 0;
  }

  .competence-content-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    padding-right: 40px;
  }

  &:hover {
    background-color: #e9ecef !important;
  }

  &[aria-expanded="true"] {
    background-color: #b23066 !important;
    border-bottom: none !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;

    h3 {
      color: #ffffff !important;
    }

    h6 {
      color: #ffffff !important;
    }
  }

  &::after {
    background: #868e96 !important;
    display: block;
    content: "";
    -webkit-mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
      no-repeat 50% 50%;
    mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
      no-repeat 50% 50%;
    -webkit-mask-size: cover;
    mask-size: cover;
    width: 20px;
    height: 20px;
    transition: all 0.15s;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  &[aria-expanded="true"]::after {
    background: #ffffff !important;
    transform: translateY(-50%) rotate(180deg);
  }
}

::v-deep .collapse {
  border: 1px solid #dee2e6;
  border-top: none;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  padding: 1rem;
}

.modality-header-content,
.level-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}

.btn-add-all-topics-small,
.btn-remove-all-topics-small {
  margin-right: 10px;
  border-radius: 4px;
  padding: 0 15px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
}

.btn-add-all-topics-small {
  background-color: #68c5b7;
  color: #fff;

  &:hover {
    background-color: #5bb3a5;
  }
}

.btn-remove-all-topics-small {
  background-color: #ef6549;
  color: #fff;

  &:hover {
    background-color: #d94c30;
  }
}

::v-deep .card-header.accordion-header {
  .modality-header-content,
  .level-header-content {
    h5 {
      margin: 0;
      pointer-events: auto;
    }
  }

  .btn-add-all-topics-small,
  .btn-remove-all-topics-small {
    pointer-events: auto;
    z-index: 10;
  }
}
</style>
